import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 引入 Element
import ElementUI from 'element-ui'
// 引入 Element 的主题文件
// import 'element-ui/lib/theme-chalk/index.css'
// 引入自定义的全局样式文件
import './styles/index.scss'
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
// 引入ladash-es的防抖机制
import { debounce } from 'lodash-es'
// 引入iconfont
import '@/assets/iconfont/iconfont.js'
import '@/assets/iconfont/iconfont.css'
// 将 Element 注册为 Vue 插件
Vue.use(ElementUI)
Vue.use(mavonEditor)
Vue.config.productionTip = false
// 全局关闭el-dialog点其他空白地方自动关闭
ElementUI.Dialog.props.closeOnClickModal.default = false

Vue.prototype.$bus = new Vue() // 添加一个全局事件总线

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// 设置一个全局的防抖指令
Vue.directive('debounce', {
  inserted: function (el, binding) {
    if (!el.__vueDebounce__) {
      // 设置一个内部变量来存储防抖函数
      el.__vueDebounce__ = {}
    }

    // 默认300ms
    const debounceFunc = debounce(binding.value, binding.arg || 300)
    el.__vueDebounce__.callback = debounceFunc
    el.addEventListener('click', debounceFunc)
  },
  update: function (el, binding) {
    if (binding.value !== binding.oldValue) {
      // 如果函数发生变化，移除旧函数的监听器
      el.removeEventListener('click', el.__vueDebounce__.callback)
      // 创建新的防抖函数，并更新监听器
      const debounceFunc = debounce(binding.value, binding.arg || 300)
      el.__vueDebounce__.callback = debounceFunc
      el.addEventListener('click', debounceFunc)
    }
  },
  unbind: function (el) {
    // 移除事件监听器，并删除保存的防抖函数
    el.removeEventListener('click', el.__vueDebounce__.callback)
    delete el.__vueDebounce__
  }
})
